var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12.1771C22 11.4224 21.9337 10.6967 21.8106 10H12V14.1171H17.6061C17.3646 15.4475 16.6307 16.5747 15.5275 17.3295V20H18.8939C20.8636 18.1471 22 15.4185 22 12.1771Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1923 22C14.9696 22 17.2981 21.1156 19 19.6072L15.6756 17.1291C14.7545 17.7217 13.5763 18.0718 12.1923 18.0718C9.51315 18.0718 7.24547 16.3345 6.43659 14H3V16.5589C4.69258 19.7868 8.17125 22 12.1923 22Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 14.1154C5.81837 13.4474 5.71517 12.7338 5.71517 12C5.71517 11.2662 5.81837 10.5526 6 9.88461V7H2.96594C2.35088 8.50304 2 10.2034 2 12C2 13.7966 2.35088 15.497 2.96594 17L6 14.1154Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1495 5.92817C13.6527 5.92817 15.0023 6.42649 16.0634 7.40516L19 4.57239C17.2269 2.97868 14.9093 2 12.1495 2C8.14718 2 4.6847 4.21324 3 7.44108L6.42059 10C7.22571 7.66554 9.48284 5.92817 12.1495 5.92817Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.4c4bdd61eb56796db96728435b766bda.svg";
export { ForwardRef as ReactComponent };